import { render, staticRenderFns } from "./ProductCoatingPriceFields.vue?vue&type=template&id=089681ed&"
import script from "./ProductCoatingPriceFields.vue?vue&type=script&lang=js&"
export * from "./ProductCoatingPriceFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports